import { Component, OnInit } from '@angular/core';
import { ApiClientService } from '../../services/api-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';

interface MenuItem {
  id: string;
  title: string;
  icon: string;
  isOpen: boolean;
  subItems: SubMenuItem[];
}

interface SubMenuItem {
  id: string;
  title: string;
  icon: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  clientImages: string[] = [
    'assets/images/partners_img/fontana.jpg',
    'assets/images/partners_img/valipile.jpg',
    'assets/images/partners_img/lipik.jpg',
    'assets/images/partners_img/fanon.jpg',
    'assets/images/partners_img/unicoop.jpg',
    'assets/images/partners_img/trapist-marija-zvijezda.jpg',
    'assets/images/partners_img/braca-ruzic.jpg',
    'assets/images/partners_img/axereal.png',
    'assets/images/partners_img/farmofit.jpg',
    'assets/images/partners_img/boso.jpg',
    'assets/images/partners_img/baf-kft.jpg',
    'assets/images/partners_img/vitaland.jpg',
    'assets/images/partners_img/mako-sombor.jpg',
    'assets/images/partners_img/zitarice-doo.jpg',
    'assets/images/partners_img/agrovet.jpg',
    'assets/images/partners_img/toni.jpg',
    'assets/images/partners_img/gitma-t.jpg',
    'assets/images/partners_img/its-sopor.jpg',
    'assets/images/partners_img/agronom.jpg',
    'assets/images/partners_img/baruz.jpg',
    'assets/images/partners_img/zito-polog.jpg',
    'assets/images/partners_img/mlin-mix.PNG'
  ];

  currentClientImage: string = '';
  currentClientIndex: number = 0;
  private clientInterval: any;

  isSidebarCollapsed = false;
  activeContent = 'dashboard';
  marqueeText = '';
  public isUserAgroUser: boolean = false;
  public isUserAgroModerator: boolean = false;
  public username = '';

  menuItemsMod: MenuItem[] = [
    // {
    //   id: 'dashboard',
    //   title: 'Dashboard',
    //   icon: 'fa-tachometer-alt',
    //   isOpen: true,
    //   subItems: [
    //     { id: 'dashboard', title: 'Overview', icon: 'fa-chart-line' },
    //     { id: 'analytics', title: 'Analytics', icon: 'fa-chart-bar' }
    //   ]
    // },
    {
      id: 'management',
      title: 'Opšte',
      icon: 'fa-users-cog',
      isOpen: false,
      subItems: [
        { id: 'poslovni-imenik', title: 'Poslovni imenik', icon: 'fa-users' },
        { id: 'firme', title: 'Firme', icon: 'fa-building' },
        { id: 'produzeci-saradnje', title: 'Produžeci saradnje', icon: 'fa-handshake' },
        { id: 'djelatnosti-firme', title: 'Djelatnosti firme', icon: 'fa-briefcase' },
        { id: 'oblasti-firme', title: 'Oblasti firme', icon: 'fa-map-marked-alt' },
        { id: 'statusi-firme', title: 'Statusi firme', icon: 'fa-info-circle' },
        { id: 'gradovi', title: 'Gradovi', icon: 'fa-city' },
        { id: 'drzave', title: 'Države', icon: 'fa-flag' },
        { id: 'obavjestenja', title: 'Obavještenja', icon: 'fa-bullhorn' },
        { id: 'korisnici', title: 'Korisnici', icon: 'fa-users' },
        { id: 'kontakti', title: 'Kontakti', icon: 'fa-address-book' },
        { id: 'ip-logovi', title: 'IP Logovi', icon: 'fa-file-alt' },
        // { id: 'roles', title: 'Role Management', icon: 'fa-user-shield' },
        // { id: 'permissions', title: 'Permissions', icon: 'fa-key' }
      ]
    },
    {
      id: 'robne-informacije',
      title: 'Robne Informacije',
      icon: 'fa-chart-pie',
      isOpen: false,
      subItems: [
        { id: 'artikli', title: 'Artikli', icon: 'fa-boxes' },
        { id: 'jedinice-mjere', title: 'Jedinice Mjere', icon: 'fa-balance-scale' },
        { id: 'opisi', title: 'Opisi', icon: 'fa-file-alt' },
        { id: 'ponude', title: 'Ponude', icon: 'fa-handshake' },
        { id: 'potraznje', title: 'Potražnje', icon: 'fa-money-bill-wave' },
        { id: 'kretanje-cijena', title: 'Kretanje Cijena', icon: 'fa-chart-line' },
        { id: 'kretanje-cijena-pdf', title: 'Kretanje Cijena PDF', icon: 'fa-file-pdf' },
        { id: 'cijene-na-ino', title: 'Cijene na ino berzama', icon: 'fa-globe' },
        // { id: 'performance', title: 'Performance', icon: 'fa-chart-line' }
      ]
    },
    {
      id: 'Mobilna Aplikacija',
      title: 'Mobilna Aplikacija',
      icon: 'fa-mobile-alt',
      isOpen: false,
      subItems: [
        { id: 'mobilne-ponude', title: 'Ponude', icon: 'fa-handshake' },
        { id: 'mobilne-potraznje', title: 'Potražnje', icon: 'fa-money-bill-wave' },
        { id: 'nudjene-cijene', title: 'Nuđene Cijene', icon: 'fa-tags' },
        { id: 'realizacije', title: 'Realizacije', icon: 'fa-check-circle' },
        { id: 'otkupne-cijene', title: 'Otkupne Cijene', icon: 'fa-dollar-sign' },
        { id: 'kurs-eura', title: 'Kurs Eura', icon: 'fa-euro-sign' },
        { id: 'vazna-obavjestenja', title: 'Važna Obavještenja', icon: 'fa-exclamation-triangle' },
        { id: 'poruke-registrovanih-korisnika', title: 'Poruke Registrovanih Korisnika', icon: 'fa-envelope' },
        { id: 'poruke-anonimnih-korisnika', title: 'Poruke Anonimnih Korisnika', icon: 'fa-comment-dots' },
        { id: 'posalji-obavjestenja', title: '!!! Pošalji Obavještenja !!!', icon: 'fa-paper-plane' }
      ]
    },
    {
      id: 'settings',
      title: 'Korisnička podešavanja',
      icon: 'fa-cogs',
      isOpen: false,
      subItems: [
        // { id: 'settings', title: 'System Settings', icon: 'fa-sliders-h' },
        { id: 'logout', title: 'Odjava', icon: 'fa-user-edit' },
        // { id: 'preferences', title: 'Preferences', icon: 'fa-cog' }
      ]
    }
  ];

  menuItemsUser: MenuItem[] = [
    {
      id: 'management',
      title: 'Opšte',
      icon: 'fa-users-cog',
      isOpen: false,
      subItems: [
        { id: 'poslovni-imenik', title: 'Poslovni imenik', icon: 'fa-users' },
        { id: 'obavjestenja', title: 'Obavještenja', icon: 'fa-bullhorn' },
      ]
    },
    {
      id: 'robne-informacije',
      title: 'Robne Informacije',
      icon: 'fa-chart-pie',
      isOpen: false,
      subItems: [
        { id: 'ponude', title: 'Ponude', icon: 'fa-handshake' },
        { id: 'potraznje', title: 'Potražnje', icon: 'fa-money-bill-wave' },
        { id: 'kretanje-cijena', title: 'Kretanje Cijena', icon: 'fa-chart-line' },
        { id: 'cijene-na-ino', title: 'Cijene na ino berzama', icon: 'fa-globe' }
      ]
    },
    {
      id: 'settings',
      title: 'Korisnička podešavanja',
      icon: 'fa-cogs',
      isOpen: false,
      subItems: [
        { id: 'logout', title: 'Odjava', icon: 'fa-user-edit' }
      ]
    }
  ];

  menuItemsAnonymous: MenuItem[] = [
    {
      id: 'robne-informacije',
      title: 'Robne Informacije',
      icon: 'fa-chart-pie',
      isOpen: false,
      subItems: [
        { id: 'ponude', title: 'Ponude', icon: 'fa-handshake' },
        { id: 'potraznje', title: 'Potražnje', icon: 'fa-money-bill-wave' }
      ]
    },
    {
      id: 'settings',
      title: 'Korisnička podešavanja',
      icon: 'fa-cogs',
      isOpen: true,
      subItems: [
        { id: 'login', title: 'Prijava', icon: 'fa-user-edit' }
      ]
    }
  ];

  constructor(private apiClient: ApiClientService, private router: Router, private route: ActivatedRoute, private userService: UserService) { }

  async ngOnInit() {
    this.isUserAgroModerator = this.userService.isUserAgroModerator();
    if (this.userService.getCurrentUsername() != null) {
      this.isUserAgroUser = await this.userService.checkUserStatus(this.userService.getCurrentUsername() || '').toPromise() as boolean;
      this.username = this.userService.getCurrentUsername() || '';
    } else {
      this.isUserAgroUser = false;
    }

    this.checkRouteForActiveContent();
    await this.updateMarqueeText();
    this.startClientSlideshow();
  }

  private checkRouteForActiveContent() {
    this.route.queryParams.subscribe(params => {
      if (params['section']) {
        this.activeContent = params['section'];
      }
    });
  }

  ngOnDestroy() {
    if (this.clientInterval) {
      clearInterval(this.clientInterval);
    }
  }

  startClientSlideshow() {
    // Show first image immediately
    this.showRandomClientImage();

    // Change image every 10 seconds
    this.clientInterval = setInterval(() => {
      this.showRandomClientImage();
    }, 10000);
  }

  showRandomClientImage() {
    let newIndex: number;

    // Ensure we don't show the same image twice in a row
    do {
      newIndex = Math.floor(Math.random() * this.clientImages.length);
    } while (newIndex === this.currentClientIndex && this.clientImages.length > 1);

    this.currentClientIndex = newIndex;
    this.currentClientImage = this.clientImages[this.currentClientIndex];
  }

  // Optional: Manual navigation methods
  nextClient() {
    this.currentClientIndex = (this.currentClientIndex + 1) % this.clientImages.length;
    this.currentClientImage = this.clientImages[this.currentClientIndex];

    // Reset the automatic slideshow timer
    this.resetSlideshowTimer();
  }

  previousClient() {
    this.currentClientIndex = (this.currentClientIndex - 1 + this.clientImages.length) % this.clientImages.length;
    this.currentClientImage = this.clientImages[this.currentClientIndex];

    // Reset the automatic slideshow timer
    this.resetSlideshowTimer();
  }

  private resetSlideshowTimer() {
    if (this.clientInterval) {
      clearInterval(this.clientInterval);
    }
    this.clientInterval = setInterval(() => {
      this.showRandomClientImage();
    }, 10000);
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;

    // Close all submenus when collapsing sidebar
    if (this.isSidebarCollapsed) {
      this.menuItemsMod.forEach(item => item.isOpen = false);
    }
  }

  toggleSubMenu(menuItem: MenuItem) {
    if (this.isSidebarCollapsed) {
      this.isSidebarCollapsed = false;
      setTimeout(() => {
        menuItem.isOpen = !menuItem.isOpen;
      }, 300);
    } else {
      menuItem.isOpen = !menuItem.isOpen;
    }
  }

  goToTransport() {
    this.activeContent = 'transport';
    // If you have a TransportComponent, make sure it's declared in your module
  }

  goToOffers() {
    this.activeContent = 'ponude';
    // If you have a PonudeComponent, make sure it's declared in your module
  }

  setActiveContent(contentId: string) {
    if(contentId === 'posalji-obavjestenja') {
      this.apiClient.refreshCache().then(() => {
        alert('Obavještenja su uspješno poslana.');
      }).catch(error => {
        console.error('Greška prilikom slanja obavještenja:', error);
        alert('Došlo je do greške prilikom slanja obavještenja.');
      });
      return;
    }

    if (contentId === 'logout') {
      localStorage.removeItem('authToken');
      localStorage.removeItem('Agroinformer-Current-User');
      window.location.href = '/home';
    }

    // if (contentId === 'cijene-na-ino') {
    //   window.open('https://docs.google.com/document/d/1GR7iEKZnMVB4mIeoBOM_ZRF-xiUev5TNDobJiaVztZA/edit', '_blank');
    //   return;
    // }
    this.activeContent = contentId;
  }

  getActiveContentTitle(): string {
    for (const menuItem of this.menuItemsMod) {
      for (const subItem of menuItem.subItems) {
        if (subItem.id === this.activeContent) {
          return subItem.title;
        }
      }
    }
    return 'Dashboard';
  }

  async updateMarqueeText() {
    let messages = ['Potpune informacije dostupne samo za korisnike - Za registraciju nas pozovite ili posaljite e-mail']; // Default fallback

    try {
      const obavjestenja = await this.apiClient.obavjestenjaAll2(5);
      if (obavjestenja && obavjestenja.length > 0) {
        messages = obavjestenja.map(x => x.tekst).filter(text => text && text.trim().length > 0) as string[];
      }
    } catch (error) {
      console.warn('Could not fetch notifications, using default messages:', error);
    }

    // Initial message
    this.marqueeText = messages[Math.floor(Math.random() * messages.length)];

    // Update periodically
    setInterval(() => {
      const randomMessage = messages[Math.floor(Math.random() * messages.length)];
      this.marqueeText = randomMessage;
    }, 8000);
  }
}